import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from "@angular/forms";

import { AuthService } from "../auth.service";
import { AppSettingsService } from "../../shared/services/app-settings.service";
import { ViewStateService } from "../../shared/services/view-state.service";
import { ReCaptcha2Component } from "ngx-captcha";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-forgot-login",
  templateUrl: "./forgot-login.component.html",
})
export class ForgotLoginComponent implements OnInit, OnDestroy {
  formError: string;
  forgotLoginForm: FormGroup;
  forgotLoginSuccess: boolean = false;
  needDob: false;
  needPhone: false;
  needZip: false;
  loginFound: string;
  private formValues = {
    last4Ssn: "",
    lastName: "",
    firstName: "",
    zipCode: "",
    dob: "",
    phoneNumber: "",
  };
  public readonly siteKey = "6LfyV20aAAAAADgafr-4CKTNvUpqd3NEsZ4nwmfB";

  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;
  @ViewChild("captchaElem", { static: true }) captchaElem: ReCaptcha2Component;

  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private appSettings: AppSettingsService,
    private viewState: ViewStateService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.buildForm();
  }

  public resolved(captchaResponse: string): void {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  onSubmit(updatedFormValues: any) {
    this.viewState.startLoading();

    this.formValues = updatedFormValues;
    this.validateForm();
    this.handleFormResult();
  }

  private handleFormResult() {
    if (!this.captchaSuccess) {
      alert("Are you not a robot?");
      this.viewState.stopLoading();
    }
    this.formError = "";
    if (this.forgotLoginForm.valid) {
      this.authService
        .forgotLogin(this.formValues)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res) => {
            let response = res;
            if (res.email != null) {
              this.loginFound = res.email;
              this.forgotLoginSuccess = true;
            } else {
              this.forgotLoginForm.get("phoneNumber").patchValue("");
              this.forgotLoginForm.get("zipCode").patchValue("");
              this.forgotLoginForm.get("dob").patchValue("");
              this.needDob = res.needDob;
              this.needPhone = res.needPhone;
              this.needZip = res.needZip;
              this.formError = res.message;
              this.forgotLoginSuccess = false;
            }
            this.viewState.stopLoading();
          },
          (e) => {
            this.formError = this.validationMessages.form;
            this.viewState.stopLoading();
          }
        );
    }
  }

  private buildForm() {
    this.forgotLoginForm = this.formBuilder.group({
      recaptcha: ["", Validators.required],
      last4Ssn: [this.formValues.last4Ssn, [Validators.required]],
      firstName: [this.formValues.firstName, [Validators.required]],
      lastName: [this.formValues.lastName, [Validators.required]],
      dob: [this.formValues.dob, []],
      phoneNumber: [this.formValues.phoneNumber, []],
      zipCode: [this.formValues.zipCode, []],
    });
  }

  private validateForm() {
    if (!this.forgotLoginForm) {
      return;
    }
    var hasErrors = false;

    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = "";
      const control = this.forgotLoginForm.get(field);
      if (control && !control.valid) {
        hasErrors = true;
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
          break;
        }
      }
    }

    if (hasErrors) this.viewState.stopLoading();
  }

  formErrors = {
    last4Ssn: "",
    firstName: "",
    lastName: "",
    zipCode: "",
    dob: "",
    phoneNumber: "",
  };

  validationMessages = {
    last4Ssn: {},
    firstName: {},
    lastName: {},
    zipCode: {},
    dob: {},
    phoneNumber: {},

    form: "Forgot password request failed.",
  };

  handleReset(): void {
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleExpire(): void {
    this.captchaSuccess = false;
    this.captchaIsExpired = true;
    this.cdr.detectChanges();
  }
  getCurrentResponse(): void {
    const currentResponse = this.captchaElem.getCurrentResponse();
    if (!currentResponse) {
      alert("There is no current response - have you submitted captcha?");
    } else {
      alert(currentResponse);
    }
  }

  getResponse(): void {
    const response = this.captchaElem.getResponse();
    if (!response) {
      alert("There is no response - have you submitted captcha?");
    } else {
      alert(response);
    }
  }

  reload(): void {
    this.captchaElem.reloadCaptcha();
  }

  getCaptchaId(): void {
    alert(this.captchaElem.getCaptchaId());
  }

  reset(): void {
    this.captchaElem.resetCaptcha();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
